import { useNavigate } from "react-router-dom"
import { AgencyRoleEnum } from "~/__generated__/graphql"
import { useCurrentUser } from "~/auth/CurrentUserContext"
import { onboardingAgencyDetailsPath } from "~/common/paths"
import { useDocumentTitle } from "~/common/useDocumentTitle"
import { Button } from "~/shadcn/ui/button"
import Text, { H1 } from "~/ui/typography"
import { ActivateRosterPlan } from "./components/ActivateRosterPlan"
import { useSkipsPlanStep } from "../useSkipsPlanStep"
import { AutoCheckoutRedirect } from "./components/AutoCheckoutRedirect"
import { ResumeCheckoutCard } from "./components/ResumeCheckoutCard"
import { SubscriptionPlanSelect } from "./components/SubscriptionPlanSelect"

export const OnboardingChoosePlanScreen = () => {
  useDocumentTitle("Choose Your Plan")
  const navigate = useNavigate()
  const { agencyRole, signupTierKey } = useCurrentUser()
  const skipsPlanStep = useSkipsPlanStep()
  const isAgencyAdmin = agencyRole === AgencyRoleEnum.AgencyAdmin

  const planPicker = (
    <div className="flex-1 flex flex-col self-stretch">
      <div className="text-defaultSecondary mb-8">Step 3/3</div>
      <H1 className="mb-2">Choose Your Plan</H1>
      <Text variant="header3">
        Select the plan that best suits your business needs. Each plan includes
        a FREE 30 day trial.
      </Text>
      <hr className="my-9" />
      <SubscriptionPlanSelect />
      <div className="mt-8 self-stretch flex-1 flex-grow flex justify-between items-end">
        {isAgencyAdmin && (
          <Button
            type="button"
            variant="ghost"
            onClick={() => navigate(onboardingAgencyDetailsPath({}))}
          >
            Back
          </Button>
        )}
      </div>
    </div>
  )

  // Talent agencies are on the free Roster plan and never pick one (ZAN-893).
  if (skipsPlanStep) {
    return <ActivateRosterPlan />
  }

  // Self-serve sign-ups arrive with a pre-selected tier (managed in Stripe), so
  // they never see the plan picker. On first load they auto-redirect to Stripe;
  // if they back out of checkout, they get a simple "resume" card rather than
  // the multi-plan picker (which was confusing and looped with company details).
  if (signupTierKey) {
    return (
      <AutoCheckoutRedirect
        tierKey={signupTierKey}
        fallback={<ResumeCheckoutCard tierKey={signupTierKey} />}
      />
    )
  }

  return planPicker
}
